import { Desktop, Mobile } from '../../../../App';
import StructureDesktop from './desktop/StructureDesktop';
import StructureMobile from './mobile/StructureMobile';
import AddNewMemberModal from '../../common/AddNewMemberModal/AddNewMemberModal';

export const TeamStructure = ({ tab }) => {
  return (
    <>
      <Desktop>
        <StructureDesktop tab={tab} />
      </Desktop>
      <Mobile>
        <StructureMobile />
      </Mobile>
      <AddNewMemberModal />
    </>
  );
};
